module.exports = __webpack_public_path__ + "img/solana.e2917a26.png";